/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum CardinalDirectionEnum {
    TO_TOP = 'TO_TOP',
    TO_BOTTOM = 'TO_BOTTOM',
    TO_LEFT = 'TO_LEFT',
    TO_RIGHT = 'TO_RIGHT',
}